import React, { Dispatch, FC, SetStateAction } from 'react'
import { FiltersPanel } from 'components/SA/Filters'
import URLConnector, { ConnectorProps as URLConnectorProps } from '../connectors/Url'
import {
  SizeFacet,
  StatusFacet,
  OrientationFacet,
  PriceFacet,
  CategoryFacet,
} from 'components/SA/Facets'
import { USER_ARTWORKS_NEXT_APP_ROUTE } from '../helpers/constants'

type ArtworkFiltersProps = URLConnectorProps & {
  setIsFiltersVisible: Dispatch<SetStateAction<boolean>>
  closeModal?: () => void
}

const ArtworkFilters: FC<ArtworkFiltersProps> = ({
  urlPath,
  setIsFiltersVisible,
  closeModal,
  totalHits,
}) => {
  const filters = [
    {
      title: 'Category',
      content: <CategoryFacet baseUrl={urlPath} nextAppRoute={USER_ARTWORKS_NEXT_APP_ROUTE} />,
      isOpen: true,
    },
    {
      title: 'Availability',
      content: <StatusFacet baseUrl={urlPath} nextAppRoute={USER_ARTWORKS_NEXT_APP_ROUTE} />,
      isOpen: true,
    },
    {
      title: 'Price',
      content: <PriceFacet baseUrl={urlPath} nextAppRoute={USER_ARTWORKS_NEXT_APP_ROUTE} />,
      isOpen: true,
    },
    {
      title: 'Size',
      content: (
        <SizeFacet
          baseUrl={urlPath}
          nextAppRoute={USER_ARTWORKS_NEXT_APP_ROUTE}
          isCustomSizeEnabled={true}
        />
      ),
      isOpen: true,
    },
    {
      title: 'Orientation',
      content: <OrientationFacet baseUrl={urlPath} nextAppRoute={USER_ARTWORKS_NEXT_APP_ROUTE} />,
      isOpen: true,
    },
  ]

  return (
    <FiltersPanel
      filters={filters}
      baseUrl={urlPath}
      nextAppRoute={USER_ARTWORKS_NEXT_APP_ROUTE}
      setIsFiltersVisible={setIsFiltersVisible}
      closeModal={closeModal}
      totalFiltered={totalHits}
    />
  )
}

export default URLConnector(ArtworkFilters)
